import React from "react";
import i18next from "../../assets/i18n/i18n";

export default class UserNotFoundLogo extends React.Component {
    render(): React.ReactElement {
        return (
            <svg
                width="62"
                height="62"
                viewBox="0 0 62 62"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`account-status-logo-${i18next.language}`}
            >
                <g clipPath="url(#clip0)">
                    <path
                        d="M3.31738 44.4383C0.705777 41.8267 -0.649592 36.771 0.305831 33.204L5.5205 13.7451C6.47592 10.1781 10.178 6.47604 13.745 5.52062L33.2039 0.305954C36.7709 -0.64947 41.8266 0.705899 44.4382 3.3175L58.6824 17.5617C61.294 20.1682 62.6477 25.229 61.7008 28.796L56.4793 48.2549C55.5239 51.8219 51.8218 55.524 48.2548 56.4794L28.7959 61.7009C25.2289 62.6563 20.1732 61.3027 17.5616 58.6911L3.31738 44.4383Z"
                        fill="#FDB530"
                    />
                    <path
                        d="M30.9922 11.75C25.0547 11.75 21.1953 14.1992 18.1523 18.5781C17.6328 19.3203 17.7812 20.4336 18.5977 20.9531L21.7891 23.4023C22.5312 23.9961 23.6445 23.8477 24.2383 23.1055C26.0938 20.8047 27.5039 19.4688 30.3984 19.4688C32.6992 19.4688 35.5195 20.8789 35.5195 23.1055C35.5195 24.8125 34.1094 25.6289 31.8828 26.8906C29.2109 28.375 25.7227 30.2305 25.7227 34.832V35.5C25.7227 36.5391 26.5391 37.2812 27.5039 37.2812H32.9219C33.8867 37.2812 34.7031 36.5391 34.7031 35.5V35.1289C34.7031 31.9375 43.9805 31.7891 43.9805 23.1797C43.9805 16.7227 37.2266 11.75 30.9922 11.75ZM30.25 39.5078C27.3555 39.5078 25.0547 41.8086 25.0547 44.6289C25.0547 47.4492 27.3555 49.75 30.25 49.75C33.0703 49.75 35.3711 47.4492 35.3711 44.6289C35.3711 41.8086 33.0703 39.5078 30.25 39.5078Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id="clip0">
                        <rect width="62" height="62" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }
}
